import Campaign from "@/common/services/campaigns";
import { modulePermissionsNames } from "@/store/permissions/modulePermissionsNames";
import store from "@/store";
import Insights from "../services/insights";

export default class AclModule {
  private constructor() {} // eslint-disable-line

  public static checkPermission(permission: string): boolean {
    const permissions = store.getters["permissions/permissions"];

    return permissions.includes(permission);
  }

  public static featureFlag(value: string): boolean {
    const permissionsObj = store.getters["permissions/permissionsObj"];
    return permissionsObj[value] || false;
  }

  public static async initPermissionsPage(): Promise<void> {
    const setWhatsappCampaign = <T>(result: PromiseSettledResult<T>) => {
      if (result.status === "fulfilled") {
        store.dispatch(
          `permissions/${modulePermissionsNames.SET_PERMISSIONS_PAGE}`,
          { pageName: "whatsapp_campaign", value: !!result.value }
        );
        store.dispatch(
          `permissions/${modulePermissionsNames.SET_PERMISSIONS_PAGE}`,
          { pageName: "whatsapp_campaign_phoneId", value: result.value }
        );
        return;
      }

      console.log("Permission page: whatsapp_campaign.\n", result.reason);
    };

    const setSmsAndAppPush = <T>(result: PromiseSettledResult<any>) => {
      if (result.status === "fulfilled") {
        store.dispatch(
          `permissions/${modulePermissionsNames.SET_PERMISSIONS_PAGE}`,
          { pageName: "sms_campaign", value: !!result.value.smsActive }
        );

        store.dispatch(
          `permissions/${modulePermissionsNames.SET_PERMISSIONS_PAGE}`,
          { pageName: "app_push_campaign", value: !!result.value.pushActive }
        );
        return;
      }

      console.log("Permission page: sms_campaign.\n", result.reason);
    };

    const setGA = <T>(result: PromiseSettledResult<T>) => {
      if (result.status === "fulfilled") {
        store.dispatch(
          `permissions/${modulePermissionsNames.SET_PERMISSIONS_PAGE}`,
          { pageName: "insights", value: result.value }
        );
        return;
      }

      console.log("Permission page: insights.\n", result.reason);
    };
    const runCallback: [
      (result: Parameters<typeof setWhatsappCampaign>[0]) => void,
      (result: Parameters<typeof setSmsAndAppPush>[0]) => void,
      (result: Parameters<typeof setGA>[0]) => void
    ] = [setWhatsappCampaign, setSmsAndAppPush, setGA];

    await Promise.allSettled([
      Campaign.hasWhatsappCampaign(),
      Campaign.getAdvancedConfigs(),
      Insights.getUserHasGA(),
    ]).then((results) => {
      results.forEach((result, i) => {
        runCallback[i](result);
      });
    });
  }

  public static permissionPage<T = boolean>(page: string): T {
    const permissionsPage = store.getters["permissions/permissionsPage"];
    return permissionsPage[page] || false;
  }

  public static routeBefore(to: any, from: any, next: any): void {
    const meta: any = to.meta;
    const nextPage = () => {
      setTimeout(() => {
        window.scrollTo(0, 0);
        next();
      }, 100);
    };

    if (typeof meta.permission === "undefined") {
      nextPage();
    } else {
      if (!AclModule.checkPermission(meta.permission)) {
        next({ name: "unauthorized" });
      } else {
        nextPage();
      }
    }
  }

  public static routeAfter(to: any): void {
    if (typeof to.query.casToken !== "undefined") {
      window.history.pushState({}, document.title, window.location.pathname);
    }
  }
}
